import { memo } from "react";

function FutureMarker(props) {
  const {
    backgroundColor = "#05A792",
    borderColor = "white",
    size = 27,
  } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_10100_46996)">
        <path
          d="M22 0H2C0.89543 0 0 0.89543 0 2V22C0 23.1046 0.89543 24 2 24H22C23.1046 24 24 23.1046 24 22V2C24 0.89543 23.1046 0 22 0Z"
          fill={backgroundColor}
        />
        <path
          d="M4.5 21C4.1 21 3.75 20.85 3.45 20.55C3.15 20.25 3 19.9 3 19.5V4.5C3 4.1 3.15 3.75 3.45 3.45C3.75 3.15 4.1 3 4.5 3H10.725C10.9417 3 11.1208 3.07083 11.2625 3.2125C11.4042 3.35417 11.475 3.53333 11.475 3.75C11.475 3.96667 11.4042 4.14583 11.2625 4.2875C11.1208 4.42917 10.9417 4.5 10.725 4.5H4.5V19.5H19.5V13.275C19.5 13.0583 19.5708 12.8792 19.7125 12.7375C19.8542 12.5958 20.0333 12.525 20.25 12.525C20.4667 12.525 20.6458 12.5958 20.7875 12.7375C20.9292 12.8792 21 13.0583 21 13.275V19.5C21 19.9 20.85 20.25 20.55 20.55C20.25 20.85 19.9 21 19.5 21H4.5ZM9.025 14.975C8.89167 14.825 8.82083 14.65 8.8125 14.45C8.80417 14.25 8.875 14.075 9.025 13.925L18.45 4.5H13.725C13.5083 4.5 13.3292 4.42917 13.1875 4.2875C13.0458 4.14583 12.975 3.96667 12.975 3.75C12.975 3.53333 13.0458 3.35417 13.1875 3.2125C13.3292 3.07083 13.5083 3 13.725 3H20.25C20.4667 3 20.6458 3.07083 20.7875 3.2125C20.9292 3.35417 21 3.53333 21 3.75V10.275C21 10.4917 20.9292 10.6708 20.7875 10.8125C20.6458 10.9542 20.4667 11.025 20.25 11.025C20.0333 11.025 19.8542 10.9542 19.7125 10.8125C19.5708 10.6708 19.5 10.4917 19.5 10.275V5.575L10.075 15C9.94167 15.1333 9.77083 15.2 9.5625 15.2C9.35417 15.2 9.175 15.125 9.025 14.975Z"
          fill={borderColor}
        />
      </g>
      <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" stroke={borderColor} />
      <defs>
        <clipPath id="clip0_10100_46996">
          <rect width="24" height="24" rx="2" fill={borderColor} />
        </clipPath>
      </defs>
    </svg>
  );
}

export default memo(FutureMarker);
